import React, { useState, useEffect } from "react";
import { AccessCategory } from "../../types/AccessCategory";
import { getAxios, route } from "../../utils/endpoints";
import { User } from "../../model/User";
import { AccessTable } from "../../types/AccessTable";

type ChartItem = {
  userId: number;
  username: string;
  chartId: number;
  description: string;
  chartType: string;
  chartCategory: string;
  isSelected: boolean;
};

export const useChartsPanel = (username?: string) => {
  const [categories, setCategories] = useState<AccessCategory[]>([]);
  const [selectedItems, setSelectedItems] = useState<number[]>([]);
  const [items, setItems] = useState<ChartItem[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const user = new User();
  const selectedUsername: string = username ? username : user.UserName;

  const disableSaveButton = user.HasForbiddenAccess(
    "Can Edit Chart Tables Tab",
  );

  const fetchChartAccessCategories = async (): Promise<void> => {
    const response = await getAxios(
      "/access/dashboard/charts/categories",
      "GET",
    );

    const data: AccessCategory[] = await response.data;

    setCategories(data);
  };

  const fetchChartAccessItems = async (): Promise<void> => {
    setIsLoading(true); // Add this here too

    const response = await getAxios(
      `/access/dashboard/charts/${selectedUsername}`,
      "GET",
    );

    const data: ChartItem[] = await response.data;

    const selectedItems = data.filter((item) => item.isSelected);
    const selectedChartItemsId = selectedItems.map((item) => item.chartId);

    setItems(data);
    setSelectedItems(selectedChartItemsId); // This should work correctly now
    setIsLoading(false);
  };

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const val: number = parseInt(event.target.value);

    if (event.target.checked) {
      setSelectedItems([...selectedItems, val]);
    } else {
      const filteredArr: number[] = selectedItems.filter(
        (item) => item !== val,
      );

      setSelectedItems(filteredArr);
    }
  };

  const onUpdateSelectedCharts = async (): Promise<void> => {
    setIsLoading(true);

    try {
      const response = await getAxios("/access/dashboard/charts", "PUT", {
        optionsIds: selectedItems,
        selectedUsername: selectedUsername,
      });

      if (response.status === 200) {
        fetchChartAccessItems();
      }
    } catch (error) {
      console.error(error);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    fetchChartAccessCategories();
    fetchChartAccessItems();
  }, []);

  return {
    categories,
    items,
    selectedItems,
    isLoading,
    onChange,
    disableSaveButton,
    onUpdateSelectedCharts,
  };
};
